
export default {
  styleOverrides: {  
    root: {
      padding: 0
    }
  },    
};